<template>
  <div class="swiper-container experience-swiper-loader">
    <div class="swiper-wrapper">
      <div
        v-for="i in range"
        :key="i"
        :class="['swiper-slide', `swiper-slide-${i + 1}`]"
      >
        <LadExperienceCardLoader />
      </div>
    </div>
  </div>
</template>

<script>
import LadExperienceCardLoader from './cards/experience-card-loader'

export default {
  name: 'LadExperienceSwiperLoader',
  components: { LadExperienceCardLoader },
  computed: {
    range() {
      return [...Array(5).keys()]
    },
  },
}
</script>

<style lang="scss">
.experience-swiper-loader {
  .swiper-slide {
    margin-right: 20px;
  }
}
</style>
